<template lang="pug">
    v-container
        v-card.elevation-12
            v-toolbar(dark color='primary')
                v-toolbar-title Verification
            v-card-text
              v-form
                v-text-field(v-model='newpassword' prepend-icon='lock' label='New password' type='password' browser-autocomplete='password' required)
                v-text-field(v-model='c_password' prepend-icon='lock' label='Confirm Password' type='password' required)
                v-text-field(v-model='no_hp' prepend-icon='phone' label='No handphone' type='text' required)
                v-otp-input( v-model='otp' length="4" prepend-icon='phone' label='otp' type='number' class="font-weight-bold text-uppercase btn-primary bg-gradient-primary py-1 px-15 me-2 mt-1 w-100")
                v-btn(v-if="otp_form==false" dark color='blue' @click='request_otp()' :loading='loadingData') Request OTP
                v-alert(v-if="otp_form==true" text type="info") Please check email or whatsapp, OTP expired in <br/> {{m}} munite : {{s}} second
            v-card-actions
                v-spacer
                v-btn(dark color='blue'  :loading='loadingData') Submit
        v-snackbar(v-model='snackbar' color='error' :timeout='6000') {{ errormsg }}
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "VerificationCard",
  data: () => ({
    newpassword: "",
    c_password:"",
    snackbar: false,
    otp: null,
    otp_form:false,
    no_hp:null,
    countDown: null,
    m: null,
    s: null,
    errormsg: "Error Failed"
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"])
  },
   created () {
            this.countDownTimer()
        },
  mounted() {
    localStorage.getItem('otp_form');
    //this.username = this.$route.query.email || '';
  },
  methods: {

    countDownTimer () {

      let count_timer = localStorage.getItem('count_timer');

         if(count_timer!=null || count_timer != 0){
            this.otp_form = true
            this.countDown=count_timer
         }
            
            if(this.otp_form == true){
             
                 this.m = Math.floor( this.countDown / 60);
                 this.s =  this.countDown % 60;
                  
                     this.m < 10 ? '0' + this.m : this.m;
                     this.s < 10 ? '0' + this.s : this.s;
                
                if (this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        localStorage.setItem('count_timer', this.countDown);
                        this.countDownTimer()
                    }, 1000)
                }else{
                   
                     this.otp_form = false
                      localStorage.setItem('otp_form', false);
                      localStorage.removeItem('count_timer');
                }
            }
                
        },

    request_otp() {

         this.countDown = 180

        let otp = localStorage.getItem('otp_form');
         localStorage.setItem('count_timer', this.countDown);
      
         if(otp == 'false'){
            this.otp_form = true
            this.countDownTimer()
            localStorage.setItem('otp_form', true);
        }
         if(otp == 'true'){
            this.countDownTimer()
            this.otp_form = false
            localStorage.setItem('otp_form', false);
        }
        if(otp == null){
            this.otp_form = false
            localStorage.setItem('otp_form', false);
        }
     
       
    },


    submit() {
    
      //const { username, password } = this;
    
    },
    showError(message) {
      this.errormsg = message;
      this.snackbar = true;
    }
  }
};
</script>
